import { QUERY } from '@skooldio/classroom-frontend-api';
import gql from 'graphql-tag';

const { products, convertProductItem, courseDetailsBanner, courseDetailsActionBox } = QUERY.Product;

// Query onlineCourse from store gateway
const onlineCourseByCourseCode = gql`
  query sfFoProductGetOnlineCourseByCourseCode($courseCode: String!) {
    sfFoProductGetOnlineCourseByCourseCode(courseCode: $courseCode) {
      id
      title
      permalink
      courseCode
      SKUCode
    }
  }
`;

const MyCourseAllExamsFragment = gql`
  fragment MyCourseAllExamsFragment on StudentCourseInfo {
    preTestExams: exams(type: PRETEST) {
      id
      examId
      title
      type
    }
    postTestExams: exams(type: POSTTEST) {
      id
      examId
      title
      type
    }
    qualificationExams: exams(type: EXAM) {
      id
      examId
      title
      type
    }
  }
`;

const ClassroomTimeFragment = gql`
  fragment ClassroomTimeFragment on ClassroomTime {
    classroomTimeId
    remainingTime
    isValidRemainingTime
    classroomTimeInfo
    type
  }
`;

const myCourses = gql`
  query myCourses($mode: STUDENT_COURSE_QUERY_MODE) {
    myCourses(mode: $mode) {
      id
      courseInfo {
        id
        title
        mode
        courseCode
        courseLevel
        subTitle
        coverImageUrl
        description
        classroomProgress {
          progressPercent
          expiryDate
          lastEnterAt
          createdAt
        }
        classroomMode
        totalActiveLearningModes
        createdAt
        ...MyCourseAllExamsFragment
      }
      classroomTime {
        ...ClassroomTimeFragment
      }
    }
  }
  ${MyCourseAllExamsFragment}
  ${ClassroomTimeFragment}
`;

const myCourse = gql`
  query myCourse($courseId: ID!) {
    myCourse(courseId: $courseId) {
      id
      courseInfo {
        id
        title
        mode
        subTitle
        coverImageUrl
        description
        courseCode
        discussUrl
        courseLevel
        classroomProgress {
          progressPercent
          expiryDate
        }
        tableOfContent {
          id
          sections {
            id
            title
            subSections {
              id
              title
              contentType
              referId
              meta {
                videoTime
              }
            }
          }
        }
        ...MyCourseAllExamsFragment
      }
    }
  }
  ${MyCourseAllExamsFragment}
`;

export {
  products,
  convertProductItem,
  myCourses,
  myCourse,
  courseDetailsBanner,
  courseDetailsActionBox,
  onlineCourseByCourseCode,
};
